import { MatDialog } from '@angular/material/dialog';
import { TemplatePortal } from '@angular/cdk/portal';
import { TemplateRef, ViewContainerRef, inject as ngInject } from '@angular/core';
import { ChangeDetectionStrategy, Component, Inject, inject, Input} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';

import { CdkPortalOutlet, Portal } from '@angular/cdk/portal';

export interface DialogButton {
  label: string;
  command: () => void | Promise<void>;
  disabled?: boolean | (() => boolean);
  /** matButton appearance: 'filled' | 'outlined' | 'tonal' | 'elevated'. dialog.html already binds
   *  this; it was simply missing from the interface. */
  style?: string;
}

@Component({
  selector: 'dialog',
  imports: [CommonModule, MatButtonModule, MatDialogActions, MatDialogTitle, MatDialogContent, CdkPortalOutlet],
  templateUrl: './dialog.html',
  styleUrl: './dialog.sass',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Dialog {
  buttons: DialogButton[] = [];
  title: string | undefined;
  readonly dialogRef = inject(MatDialogRef<Dialog>);
  @Input() content!: Portal<any>;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { buttons: DialogButton[], title: string}) {
    this.buttons = data.buttons;
    this.title = data.title;
  }

  public resolve(condition?: boolean | (() => boolean)) {
    if (condition === undefined || condition === null) return false;
    if (typeof condition === 'boolean') return condition;

    const result = condition();
    return result;
  }
}
